import { track } from '@eventbrite/datalayer-library';
import { gettext } from '@eventbrite/i18n';

import { Button, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { CloseableDialog } from '../../../../../../components/CloseableDialog';
import {
    VideoAdsEventbriteLogo,
    VideoAdsUpsell,
} from '../../../../components/SearchVideoAdsUpsell';
import styles from './SearchResultPanelInterlacedVideoAdsUpsell.module.scss';

const HEAP_CLICK_ADS_LINK =
    'Ads Video Entry point - Click - Interlaced Search link';

export type SearchResultsPanelInterlacedVideoAdsUpsellProps =
    React.PropsWithoutRef<{}>;

export function SearchResultsPanelInterlacedVideoAdsUpsell(
    props: SearchResultsPanelInterlacedVideoAdsUpsellProps,
) {
    const trackUpsellLink = () =>
        track({
            eventName: HEAP_CLICK_ADS_LINK,
            eventData: {
                interface: 'Search - Promoted',
            },
        });

    return (
        <CloseableDialog
            as="aside"
            className={styles.root}
            iconClassName={styles.closeIcon}
            {...props}
        >
            <VideoAdsUpsell
                data-testid="video-ads-upsell"
                className={styles.video}
            />
            <section className={styles.info}>
                <VideoAdsEventbriteLogo
                    data-testid="video-ads-eventbrite-logo"
                    className={styles.logo}
                    onLinkClick={trackUpsellLink}
                />
                <Typography
                    className={styles.callout}
                    variant="body-md-bold"
                    color="black"
                >
                    {gettext(
                        'Grow your community and revenue—all at the same time',
                    )}
                </Typography>
                <a
                    href="/organizations/marketing/eventbrite-ads"
                    target="_blank"
                    onClick={trackUpsellLink}
                    className={styles.link}
                >
                    <Button variant="primary">{gettext('Get started')}</Button>
                </a>
            </section>
        </CloseableDialog>
    );
}
